export const ENABLE_APP_CHECK = getEnvBoolean('VITE_ENABLE_APP_CHECK', true);
export const RECAPTCHA_SITE_KEY = getEnvString('VITE_RECAPTCHA_SITE_KEY', '');
export const FIREBASE_CONFIG = getEnvString('VITE_FIREBASE_CONFIG', '');
export const MAPBOX_TOKEN = getEnvString('VITE_MAPBOX_TOKEN', '');
export const BASE_URL_EU = getEnvString(
    'VITE_BASE_URL_EU',
    'https://api.safepointapp.com'
);
export const BASE_URL_US = getEnvString(
    'VITE_BASE_URL_US',
    'https://api.us.safepointapp.com'
);
export const SENTRY_DSN = getEnvString('VITE_SENTRY_DSN', '');
export const SENTRY_ENVIRONMENT = getEnvString(
    'VITE_SENTRY_ENVIRONMENT',
    'development'
);
export const INTERCOM_APP_ID = getEnvString('VITE_INTERCOM_APP_ID', '');

/**
 * SSO client ids. A provider with no client id in this build is hidden rather
 * than shown failing — see `getEnabledSsoProviders`.
 */
export const GOOGLE_SSO_CLIENT_ID = getEnvString(
    'VITE_GOOGLE_SSO_CLIENT_ID',
    ''
);
export const MICROSOFT_SSO_CLIENT_ID = getEnvString(
    'VITE_MICROSOFT_SSO_CLIENT_ID',
    ''
);

function getEnvString(key: string, defaultValue = ''): string {
    const value: unknown = import.meta.env[key];

    if (typeof value !== 'string') {
        return defaultValue;
    } else {
        return value;
    }
}

function getEnvBoolean(key: string, defaultValue = true): boolean {
    const value = `${import.meta.env[key]}`;

    if (['true', '1', 'yes', 'enabled', 'on'].includes(value.toLowerCase())) {
        return true;
    } else if (
        ['false', '0', 'no', 'disabled', 'off'].includes(value.toLowerCase())
    ) {
        return false;
    }
    return defaultValue;
}
